import { CSSProperties } from 'react';
import { ENVIRONMENTS } from '../../services/exports/Constants';

export default function EnvironmentBanner() {
  function getStyle(): CSSProperties {
    const backgroundColor = () => {
      switch (import.meta.env.VITE_MODE) {
        case ENVIRONMENTS.DEV:
          return '#000000';
        case ENVIRONMENTS.STAGING:
          return '#F89A2A';
        default:
          return '';
      }
    };

    return {
      zIndex: 1000,
      backgroundColor: backgroundColor(),
      height: 25,
    };
  }

  return (
    <>
      <div className="w-full flex items-center justify-center" style={getStyle()} id={'env-banner'}>
        <p className="text-xs font-medium text-white-100">{import.meta.env.VITE_MODE}</p>
      </div>
    </>
  );
}
